/** @format */

import {Box, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

import {sharedClasses} from '../sharedStyles';

export {ChartArea, ForecastLabel, RowLabel, RowValue, SummaryGrid} from '../sharedStyles';

// Re-export sharedClasses as `classes` so consumers keep the same import unchanged.
export const classes = sharedClasses;

// KPI column container — just stacks the KPI rows. The bordered rounded box is the parent
// MetricsRoot (one box around KPI + Расход); Figma node 10284:124679 ("kpi block").
export const ChartsRoot = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  width: '100%',
}));

// One KPI row: text block (left) + chart (right). Figma node 10284:124680 — flex gap 16, p 16.
export const KpiRow = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'stretch',
  gap: theme.spacing(4),
  padding: theme.spacing(4),
  width: '100%',
}));

// Divider between KPI rows — full width, surface-2. Figma node 1261:2001 (horizontal).
export const RowDivider = styled(Box)(({theme}) => ({
  height: 0,
  width: '100%',
  borderTop: `1px solid ${theme.palette.semantic_dark?.surface.surface2}`,
}));

// Left text block: column, gap 8px. Figma node 10284:124681.
export const TextBlock = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(2),
  flexShrink: 0,
}));

// KPI label — 16px / 20px medium, onSurface. Figma node 10284:124682.
export const KpiLabel = styled(Typography)(({theme}) => ({
  fontSize: 16,
  lineHeight: '20px',
  fontWeight: 500,
  color: theme.palette.semantic_dark?.surface.onSurface,
  whiteSpace: 'nowrap',
}));
